"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.membersTypes = exports.InviteMembershipParameters = exports.BuyMembershipParameters = exports.StakingAccountMemberBinding = exports.Membership = void 0;
const types_1 = require("@polkadot/types");
const common_1 = require("./common");
class Membership extends (0, common_1.JoyStructDecorated)({
    handle_hash: types_1.Bytes,
    root_account: common_1.AccountId,
    controller_account: common_1.AccountId,
    verified: types_1.bool,
    invites: types_1.u32,
}) {
}
exports.Membership = Membership;
class StakingAccountMemberBinding extends (0, common_1.JoyStructDecorated)({
    member_id: common_1.MemberId,
    confirmed: types_1.bool,
}) {
}
exports.StakingAccountMemberBinding = StakingAccountMemberBinding;
class BuyMembershipParameters extends (0, common_1.JoyStructDecorated)({
    root_account: common_1.AccountId,
    controller_account: common_1.AccountId,
    handle: types_1.Option.with(types_1.Text),
    metadata: types_1.Bytes,
    referrer_id: types_1.Option.with(common_1.MemberId),
}) {
}
exports.BuyMembershipParameters = BuyMembershipParameters;
class InviteMembershipParameters extends (0, common_1.JoyStructDecorated)({
    inviting_member_id: common_1.MemberId,
    root_account: common_1.AccountId,
    controller_account: common_1.AccountId,
    handle: types_1.Option.with(types_1.Text),
    metadata: types_1.Bytes,
}) {
}
exports.InviteMembershipParameters = InviteMembershipParameters;
exports.membersTypes = {
    Membership,
    StakingAccountMemberBinding,
    BuyMembershipParameters,
    InviteMembershipParameters,
};
exports.default = exports.membersTypes;
